// @flow strict

// author: cahuja
// since: Nov 01, 2019
/* eslint-disable ta-code-conventions/has-matching-storydoc, ta-code-conventions/has-matching-test */

import * as React from 'react';

type Props = {|
  children: React.Node,
|};

// We want to initialize this as fast as possible so that we're not blocking page render on network.
// Additionally, it's important to ensure we only attempt this call *once* to minimize its impact.
const memoized =
  // eslint-disable-next-line ta-code-conventions/lithium-string-blacklist
  SERVER || typeof fetch === 'undefined'
    ? new Promise(() => {})
    : fetch('/static/decodeKey.txt', {
        method: 'GET',
        redirect: 'error',
        credentials: 'same-origin',
      })
        .then(res => !!res.ok)
        .catch(() => false);

/**
 * A hook to fetch decodeKey.txt (which is disallowed per robots.txt)
 * Nothing is fetched during SSR since useEffect is a no-op during SSR
 * The result of the fetch is memoized as the useEffect will be run only once
 * Ergo, useIsRobotSafe will return true for non-bot users
 */
export const useIsRobotSafe = (): boolean => {
  const [isRobotSafe, setIsRobotSafe] = React.useState(false);
  React.useEffect(() => {
    memoized.then(setIsRobotSafe);
  }, []);
  return isRobotSafe;
};

const RobotSafeClientOnly = (props: Props) => {
  const isRobotSafe = useIsRobotSafe();

  return isRobotSafe ? props.children : null;
};

/**
 * A component that renders passed in children(React.Node) on clients if and only if they can fetch
 * decodeKey.txt (which is disallowed per robots.txt)
 */
export default RobotSafeClientOnly;
